(function () {
  'use strict';

  var rssBlocks = {};
  var $moreRss;
  var $expandRssFeed;
  $(document).ready(function () {
    $(".toggle-expand-hide-link").map(function () {
      var dataId = $(this).attr("data-id");
      rssBlocks[dataId] = false;
    });
    $(".toggle-expand-hide-link").click(function () {
      var dataId = $(this).attr("data-id");
      var expanded = rssBlocks[dataId];
      $moreRss = $(".expand-posts." + dataId);
      $expandRssFeed = $(this);

      if (expanded) {
        hideExpanded();
      } else {
        expand();
      }

      expanded = !expanded;
      rssBlocks[dataId] = expanded;
    });
  });

  function hideExpanded() {
    $moreRss.hide();
    $expandRssFeed.find(".text.hide-posts").hide();
    $expandRssFeed.find(".show-all-posts").hide();
    $expandRssFeed.find(".text.expand-posts").show();
    $expandRssFeed.find(".caret").removeClass("caret-rotate");
  }

  ;

  function expand() {
    $moreRss.show();
    $expandRssFeed.find(".text.hide-posts").show();
    $expandRssFeed.find(".show-all-posts").show();
    $expandRssFeed.find(".text.expand-posts").hide();
    $expandRssFeed.find(".caret").addClass("caret-rotate");
  }
})();